// export const isBrowser = () => typeof window !== "undefined"
// export const getUser = () =>
//   isBrowser() && window.localStorage.getItem("gatsbyUser")
//     ? JSON.parse(window.localStorage.getItem("gatsbyUser"))
//     : {}
// const setUser = user =>
//   window.localStorage.setItem("gatsbyUser", JSON.stringify(user))

export const login = async ({ userName, password }) => {
  const formData = new FormData();
  formData.append('name', userName);
  formData.append('password', password);

  // form 데이터를 json으로 변경한다
  const data = {};
  formData.forEach((value, key) => {
    data[key] = value;
  });
  const json = JSON.stringify(data);

  const response = await fetch(`${process.env.REACT_APP_API_URL}/api/login`, {
    method: 'POST',
    mode: 'cors',
    // cache: 'no-cache',
    // credentials: 'omit',
    headers: {
      'Content-Type': 'application/json; charset=utf-8',
    },
    body: json,
  });

  if (response.status !== 200) {
    throw new Error('Login Failed');
  }

  const responseJson = await response.json();
  if (!responseJson.data.error) {
    const { token } = responseJson.data;
    if (typeof localStorage !== 'undefined') localStorage.setItem('id_token', token);
    return true;
  }

  return false;
};

export const isLoggedIn = () => {
  if (typeof localStorage !== 'undefined') {
    return !!localStorage.getItem('id_token');
  }

  return false;
};

export const getToken = () => {
  if (typeof localStorage !== 'undefined') {
    return localStorage.getItem('id_token');
  }
  return '';
};

export const logout = () => {
  if (typeof localStorage !== 'undefined') {
    localStorage.removeItem('id_token');
  }
};
